import { authFetch } from "../../../../../api";

export const getLessonPlan = async (requestData) => {
  try {
    const response = await authFetch("stm-route/lesson-plan-days", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("Error creating course:", err.message);
  }
};


export const getLessonPlanForOneDay = async (requestData) => {
  try {
    const response = await authFetch("stm-route/lesson-plan-one-day", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("cant find lesson plan :", err.message);
  }
};
